import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CiLocationOn } from 'react-icons/ci';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';
import google from './img/Google reviews.png'
import { BiPhoneCall } from 'react-icons/bi';
const Footer = () => {
    return (
        <footer className="shadow pt-5 pb-3 text-white" style={{ backgroundColor: '#093c60' }}>
            <Container>
                <Row>
                    {/* Client Resources */}
                    <Col xs={12} md={3} className="mb-4 text-center text-md-left">
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1 }}
                        >
                            <h3 className="mb-3 txt text-white link-hover">Client Resources</h3>
                            <motion.h5
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 1, delay: 0.4 }}
                                className="link-hover"
                            >
                                Schedule consult<br />
                                Find your Health Plan<br />
                                Order supplements<br />
                                Resources
                            </motion.h5>

                        </motion.div>


                    </Col>


                    {/* Navigation Links */}
                    <Col xs={12} md={3} className="mb-4 text-center text-md-left">
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 0.4 }}
                        >
                            <h5 className="mb-3 fw-bold link-hover">Menu</h5>
                            <motion.ul
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 1, delay: 0.6 }}
                                style={{ listStyleType: 'none', padding: 0 }} // Remove bullet points and padding
                            >
                                <li className="list-none mb-3"> {/* Adjust spacing between links */}
                                    <Link to="/" className="text-white no-underline link-hover fw-bold">Home</Link>
                                </li>
                                <li className="list-none mb-3">
                                    <Link to="/About" className="text-white no-underline link-hover fw-bold">About</Link>
                                </li>
                                <li className="list-none mb-3">
                                    <Link to="/Blog" className="text-white no-underline link-hover fw-bold">Our Blog</Link>
                                </li>
                                <li className="list-none mb-3">
                                    <Link to="/Treatment" className="text-white no-underline link-hover fw-bold">Treatments</Link>
                                </li>
                            </motion.ul>
                        </motion.div>
                    </Col>

                    {/* Help & Support */}
                    <Col xs={12} md={3} className="mb-4 text-center text-md-left">
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 0.8 }}
                        >
                            <h5 className="txt mb-3 fw-bold text-white link-hover">Help & Support</h5>
                            <motion.ul
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 1, delay: 1 }}
                                style={{ listStyleType: 'none', padding: 0 }} // Remove bullet points and padding
                            >
                                <li className="list-none mb-3">
                                    <Link to="/Contact" className="text-white no-underline link-hover fw-bold">Contact</Link>
                                </li>
                                <li className="list-none mb-3">
                                    <Link to="/Any_Questions" className="text-white no-underline link-hover fw-bold">Common Ask Question</Link>
                                </li>
                                <li className="list-none mb-3">
                                    <Link to="/Any_Questions" className="text-white no-underline link-hover fw-bold d-flex align-items-center gap-2">
                                        <BiPhoneCall size={20} />
                                        <span>Book Appointment</span>
                                    </Link>
                                    
                                    <span className="text-white fw-bold">+91 9607899660</span><br></br>
                                    <span className="text-white fw-bold">+91 9579542771</span><br></br>
                                </li>


                            </motion.ul>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 0.6 }}
                            className="google-rating mt-5  align-items-center"
                        >
                            <div className="rating-stars align-items-center">
                                <FaStar className="star" />
                                <FaStar className="star" />
                                <FaStar className="star" />
                                <FaStar className="star" />
                                <FaStarHalfAlt className="star-half" />
                                <span className="text-white text-md-left"><b> 450 reviews</b></span>
                            </div>

                            <img src={google}
                                className='w-50 h-50  text-center'
                                alt="Google reviews" />
                        </motion.div>
                    </Col>

                    {/* Map Section */}
                    <Col xs={12} md={3}>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 1.2 }}
                        >
                            <h5 className="txt mb-3 fw-bold">Our Location</h5>
                            <div className="map-responsive">
                                <iframe
                                    title="location-map"
                                    frameBorder="0"
                                    style={{ border: 0, width: '100%', height: '100%', borderRadius: '8px' }}
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d77054.31409843857!2d73.74275349857025!3d19.988116424324804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1737626046129!5m2!1sen!2sin"
                                    allowFullScreen=""
                                    aria-hidden="false"
                                    tabIndex="0"
                                ></iframe>
                                <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start">
                                    <CiLocationOn className="mr-2" size={80} />
                                    <span className="mx-2 d-flex align-items-center">
                                        <span className="link-hover font-bold">
                                            <b>Location:</b> Solitaire building 2nd floor above Lolo Cafe, College Road, Nashik
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </motion.div>

                    </Col>
                </Row>

                {/* Copyright Section */}
                <Row className="text-center mt-4">
                    <Col>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 1.4 }}
                        >
                            <p className="mb-0 fw-bold">
                                &copy; {new Date().getFullYear()} Swati Chavhan Vanjari. All rights reserved | Designed by
                                <a href="https://dynografx.com/" target="_blank" rel="noopener noreferrer" className="ms-1 text-decoration-none fw-bold">
                                    DynoGrafx Solutions
                                </a>
                            </p>
                        </motion.div>
                    </Col>
                </Row>

            </Container>
        </footer>
    );
};

export default Footer;
